/** 新品申请-列表 */
export const SUPPLIER_SELF_SERVICE_PRODUCT_PAGE = {
  url: 'api/supplier/self/service/product/page',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/** 新品申请-发起申请 */
export const SUPPLIER_SELF_SERVICE_PRODUCT_ADD = {
  url: 'api/supplier/self/service/product/add',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/** 新品申请-编辑申请 */
export const SUPPLIER_SELF_SERVICE_PRODUCT_UPDATE = {
  url: 'api/supplier/self/service/product/update',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/** 新品申请-申请详情 */
export const SUPPLIER_SELF_SERVICE_PRODUCT_INFO = {
  url: 'api/supplier/self/service/product/info',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/** 新品申请-批量撤回 */
export const SUPPLIER_SELFT_SERVICE_PRODUCT_BATCH_WITHDRAW = {
  url: 'api/supplier/self/service/product/batch/withdraw',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/** 新品申请-审批流详情 */
export const SUPPLIER_SELFT_SERVICE_PRODUCT_FLOW_RECORD = {
  url: 'api/supplier/self/service/product/flow/record',
  config: {
    method: 'get',
    host: 'SUPPLIER',
  },
};

/** 新品申请-税码 */
export const SUPPLIER_SELFT_SERVICE_PRODUCT_TAX_ALL = {
  url: 'api/supplier/self/service/product/tax/all',
  config: {
    method: 'get',
    host: 'SUPPLIER',
  },
};

/** 新品申请-商品单位 */
export const SUPPLIER_SELFT_SERVICE_PRODUCT_DIC_TYPE = {
  url: 'api/supplier/self/service/product/dic/type',
  config: {
    method: 'get',
    host: 'SUPPLIER',
  },
};

/** 新品申请-商品下拉列表 */
export const SUPPLIER_SELFT_SERVICE_PRODUCT_PRODUCT_LIST = {
  url: 'api/supplier/self/service/product/product/list',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/** 新品申请-BBC新建 */
export const SUPPLIER_BBCPRODUCT_ADD = {
  url: 'bbcSupplier/product/add',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/** 新品申请-BBC取消 */
export const SUPPLIER_BBCPRODUCT_CANCEL = {
  url: 'bbcSupplier/product/cancel',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/** 新品申请-BBC编辑 */
export const SUPPLIER_BBCPRODUCT_UPDATE = {
  url: 'bbcSupplier/product/update',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/** 新品申请-BBC详情 */
export const SUPPLIER_BBCPRODUCT_DETAIL = {
  url: 'bbcSupplier/product/queryDetail',
  config: {
    method: 'get',
    host: 'SUPPLIER',
  },
};
/** 新品申请-查询 */
export const SUPPLIER_BBCPRODUCT_QUERYPAGE = {
  url: 'bbcSupplier/product/queryByPage',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/** 新品申请-品牌 */
export const SUPPLIER_BBCPRODUCT_GETBRANDINFO = {
  url: 'bbcSupplier/product/getBrandInfo',
  config: {
    method: 'get',
    host: 'SUPPLIER',
  },
};

/** 新品申请-人员 */
export const SUPPLIER_BBCPRODUCT_GETROLEINFO = {
  url: 'bbcSupplier/product/getRoleInfo',
  config: {
    method: 'get',
    host: 'SUPPLIER',
  },
};

/** 新品申请-BBC 新建 */
export const SUPPLIER_POST_BBCPRODUCT_ADD_BY_WELFARE_CREATE_PRODUCT = {
  url: 'bbcSupplier/product/addByWelfareCreateProduct',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/** 新品申请-BBC 编辑 */
export const SUPPLIER_POST_BBCPRODUCT_UPDATE_BY_WELFARE_CREATE_PRODUCT_BATCH = {
  url: 'bbcSupplier/product/updateByWelfareCreateProduct',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/** 新品申请-BBC 查看详情 */
export const SUPPLIER_POST_BBCPRODUCT_WELFARE_CREATE_PRODUCT = {
  url: 'bbcSupplier/product/queryDetailByWelfareCreateProduct',
  config: {
    method: 'get',
    host: 'SUPPLIER',
  },
};

/** 校验京东对标链接*/
export const SUPPLIER_POST_NEW_BENEFIT_CHECKJDURL = {
  url: 'new/benefit/bbc/supplier/product/checkJdUrl',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/** 获取商品详细信息*/
export const SUPPLIER_POST_BENEFIT_GETPRODUCTINFOBYCODES = {
  url: 'bbcSupplier/product/getProductInfoByCodes',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/** 商品条码校验-条码是否存在 */
export const SUPPLIER_BBCSUPPLIER_PRODUCT_VALID_BARCODE_EXIST = {
  url: 'bbcSupplier/product/validBBCBarcodeExist',
  config: {
    method: 'get',
    host: 'SUPPLIER',
  },
};
